import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { RadioContainer } from '#component/project/form/project/styles';
import { convertTemperature, convertTemperatureToString, convertTemperatureUnit } from '#helper';

/**
 * Returns temperature label based on
 * range of temperatures and measurement system
 * @param {number | string} minT - minimum temperature
 * @param {number | string} maxT - maximum temperature
 * @param {string} measurementSystem - measurementSystem
 * @returns {string} label string
 */

const getLabel = (minT, maxT, measurementSystem) => {
  if (maxT === minT) {
    return convertTemperatureToString(minT, measurementSystem);
  }
  return `${convertTemperature(minT, measurementSystem)} - ${convertTemperature(maxT, measurementSystem)}${convertTemperatureUnit(measurementSystem)}`;
};

export default ({
  input,
  data,
  label,
  disabled,
  account,
  isTemperature,
  meta,
  ...rest
}) => (
  <RadioContainer
    component="fieldset"
    disabled={disabled}
  >
    <FormLabel component="legend">{label}</FormLabel>
    <RadioGroup {...input} {...rest} row>
      {data.items.map(item => (
        <FormControlLabel
          key={item.id}
          value={item.value}
          control={<Radio />}
          label={
            isTemperature ?
              getLabel(item.minT, item.maxT, account && account.measurementSystem) :
              item.label
          }
        />
      ))}
    </RadioGroup>
    {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
  </RadioContainer>
);
